const stripPathVersions = (attributePath) => {
    if (!attributePath) {
        return attributePath;
    }

    return attributePath.replace(/\d./g, '').replace(/\d+$/, ''); // remove trailing version numbers
};

module.exports = {
    stripPathVersions
};
